import { SelectedOptionsType } from './selectedOptions'

export const initialState: SelectedOptionsType = {
  options: {},
  filled: false
}
